import {EntityModel} from "@fedeltapointofsale/data-client";
import {SizeGroupData} from "./size-group.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SizeGroupEntityModel extends EntityModel<SizeGroupData> {

    constructor(injector: Injector) {
        super(injector, SizeGroupData);
    }
}
